// Central contact constants for AIOTrade.
export const CONTACT = {
  whatsappNumber: "6287753674262",
  whatsappDisplay: "+62 877-5367-4262",
  whatsappAdmin:
    "https://wa.me/6287753674262?text=Halo%20AIOTRADE%2C%20saya%20tertarik%20untuk%20mengetahui%20lebih%20lanjut",
  whatsappGroup: "https://chat.whatsapp.com/CYy6nWq9UT05BehyWYh309?mode=gi_t",
  whatsappChannel: "https://whatsapp.com/channel/0029VakJs0mDOQIgIpWkVk30",
  telegramAdmin:
    "https://t.me/aiotrade_id?text=Halo%20AIOTRADE%2C%20saya%20tertarik%20untuk%20mengetahui%20lebih%20lanjut",
  telegramGroup: "https://t.me/aiotradeID",
  facebookPage: "https://www.facebook.com/61584801729901",
  facebookGroup: "https://www.facebook.com/groups/aiotrade.id",
  registration: "https://aiotrade.co/?r=Mrej2mtJ",
  userGuide: "https://aiotrade.id/AIOTRADE-User-Guide.pdf",
  marketingPlan: "https://aiotrade.id/AIOTRADE_Marketing_Plan.pdf",
  youtubeTutorial: "https://www.youtube.com/watch?v=e_P-bPBOqQw",
  bappebtiCheck: "https://ceklegalitas.bappebti.go.id/",
};
